import {debug} from "util";

import {TextControlOptions} from "./TextControl.Options";
import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";
import {GroupProperties} from "InternalShared/PageBuilder/Controls/Properties/styles/GroupProperties";
import {DimensionStyleSet} from "InternalShared/PageBuilder/Controls/Properties/StyleSets/DimensionStyleSet";
import {ColorProperty} from "InternalShared/PageBuilder/Controls/Properties/ColorProperty";
import {NumberProperty} from "InternalShared/PageBuilder/Controls/Properties/NumberProperty";
import {ButtonProperties} from "InternalShared/PageBuilder/Controls/Properties/ButtonProperties";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {AllowedResizeDirection} from "InternalShared/Dto";
import {FieldSummaryOptions} from "PageBuilder/pagebuilder/Controls/ControlsList/FieldSummary.Options";
import React = require("react");
import {FieldsProperty} from "InternalShared/PageBuilder/Controls/Properties/FieldsProperty";
import {PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {HTMLTableCreator} from "shared/utilities/HTMLTableCreator/HTMLTableCreator";
import {FontFamilyProperty} from "InternalShared/PageBuilder/Controls/Properties/FontFamilyProperty";
import {library} from "@fortawesome/fontawesome-svg-core";
import {FieldControlOptions} from "PageBuilder/pagebuilder/Controls/ControlsList/FieldControl.Options";


declare let rednaoPDFInvoiceParams:any;

export class FieldSummary extends PDFControlBase{


    GetStyles(): GroupProperties[] {

            return [
                DimensionStyleSet.GetStyles(this),
                new GroupProperties('Container').AddProperties([
                    new ColorProperty(this,'border-color',this.StyleManager.CreateStyleClassManager('table.SummaryTable')).SetLabel('Border Color'),
                ]),
                new GroupProperties('Label Styles').AddProperties([
                    new FontFamilyProperty(this,'font-family',this.StyleManager.CreateStyleClassManager('.FieldLabel p')).SetLabel('Font Size'),
                    new NumberProperty(this,'font-size',this.StyleManager.CreateStyleClassManager('.FieldLabel p')).SetLabel('Font Size').SetPlaceholder('Default'),
                    new ColorProperty(this,'color',this.StyleManager.CreateStyleClassManager('.FieldLabel p')).SetLabel('Font Color').AddStyles({width:'50%',display:'inline-block'}),
                    new ColorProperty(this,'background-color',this.StyleManager.CreateStyleClassManager('.FieldLabel')).SetLabel('Background Color').AddStyles({width:'50%',display:'inline-block'}),
                    new ButtonProperties(this,'text-align',this.StyleManager.CreateStyleClassManager('.FieldLabel p')).SetLabel('Alignment')
                        .AddButton('left',<FontAwesomeIcon icon={"align-left"}/>)
                        .AddButton('center',<FontAwesomeIcon icon={"align-center"}/>)
                        .AddButton('right',<FontAwesomeIcon icon={"align-right"}/>),
                    new ButtonProperties(this,'text-align',this.StyleManager.CreateStyleClassManager('.FieldLabel p')).SetLabel('Styles').AllowMultiple()
                        .AddButton('normal',<FontAwesomeIcon icon={"bold"}/>,'font-weight',true)
                        .AddButton('italic',<FontAwesomeIcon icon={"italic"}/>,'font-style')
                ]),
                new GroupProperties('Value Styles').AddProperties([
                    new FontFamilyProperty(this,'font-family',this.StyleManager.CreateStyleClassManager('.FieldValue p')).SetLabel('Font Size'),
                    new NumberProperty(this,'font-size',this.StyleManager.CreateStyleClassManager('.FieldValue p')).SetLabel('Font Size').SetPlaceholder('Default'),
                    new ColorProperty(this,'color',this.StyleManager.CreateStyleClassManager('.FieldValue p')).SetLabel('Font Color').AddStyles({width:'50%',display:'inline-block'}),
                    new ColorProperty(this,'background-color',this.StyleManager.CreateStyleClassManager('.FieldValue')).SetLabel('Background Color').AddStyles({width:'50%',display:'inline-block'}),
                    new ButtonProperties(this,'text-align',this.StyleManager.CreateStyleClassManager('.FieldValue p')).SetLabel('Alignment')
                        .AddButton('left',<FontAwesomeIcon icon={"align-left"}/>)
                        .AddButton('center',<FontAwesomeIcon icon={"align-center"}/>)
                        .AddButton('right',<FontAwesomeIcon icon={"align-right"}/>),
                    new ButtonProperties(this,'text-align',this.StyleManager.CreateStyleClassManager('.FieldValue p')).SetLabel('Styles').AllowMultiple()
                        .AddButton('bold',<FontAwesomeIcon icon={"bold"}/>,'font-weight')
                        .AddButton('italic',<FontAwesomeIcon icon={"italic"}/>,'font-style')



                ])

            ];
    }
    public AllowedResizeDirection:AllowedResizeDirection="horizontal";
    public Options:FieldSummaryOptions;
    private properties:GroupProperties[];



    public InternalInitialize() {

    }


    SetInitialStyles() {
        super.SetInitialStyles();
        this.StyleManager.AddStyleSet('.FieldLabel,.FieldValue',{'text-align':'left','padding':'10px'});
        this.StyleManager.AddStyleSet('.FieldLabel',{'font-weight':'bold','background-color':'#ecf3fb'});
        this.StyleManager.AddStyleSet('.FieldValue',{'background-color':'#ffffff'});
        this.StyleManager.AddStyleSet('.SummaryTable',{border:'1px #dfdfdf solid'});
        this.StyleManager.AddStyleSet('table.SummaryTable',{'border-color':'#dfdfdf'});
        this.StyleManager.AddStyleSet('table',{'width':'100%'});
    }

    public NeedTranslations(): boolean {
        return true;
    }

    public GetTranslatedText(): any {
        return {text:''};
    }

    protected InternalGenerateHtml($container: JQuery) {
        this.GenerateTable($container[0]);
    }

    public GetProperties(): GroupProperties[] {
        if(this.properties==null)
        {

            this.properties=[new GroupProperties('General')
                .AddProperties([
                    new FieldsProperty(this,'Fields').SetLabel('Fields').Focus()
                ])];
        }

        return this.properties;
    }


    public AfterRefresh() {
        let height:number=this.$element.find('.elementContent').height();
        this.$element.velocity('stop',true);
        this.$element.velocity(200,"easeInExp");

    }

    GetInitialOptions(): Promise<PDFControlBaseOptions> {

        return new Promise(resolve => {
            let fields=this.Page.Form.Fields;
            let summaryFields:any[]=[];
            for(let field of fields)
            {
                summaryFields.push({Id:field.Id,Label:field.Label,FieldSettings:new FieldControlOptions().Merge()});
            }
            resolve(new FieldSummaryOptions().Merge(
                {
                    Styles:{Left:'2%',Width:'96%'},
                    Fields:summaryFields

                })
            );
        });
    }

    private GenerateTable(container:HTMLElement) {
        container.style.maxHeight='500px';
        container.style.overflow='hidden';
        let creator=new HTMLTableCreator('SummaryTable');
        container.appendChild(creator.Table);
        creator.CreateTBody();

        if(this.Options.Fields.length==0)
        {
            creator.CreateRow();
            creator.CreateTextColumn('No fields to display for this form =(');
        }
        for(let field of this.Options.Fields)
        {

            creator.CreateRow();
            let fieldSettings=this.Page.Form.Fields.find(x=>x.Id==field.Id.toString());

            let subCreator=new HTMLTableCreator('');
            subCreator.CreateTHead('');
            subCreator.CreateRow();
            subCreator.CreateTextColumn(field.Label,'FieldLabel');
            subCreator.CreateTBody();
            subCreator.CreateRow();
            if(fieldSettings==null)
            {
                let text=document.createElement('p');
                text.style.color='red';
                text.style.fontStyle='bold';
                text.innerText='Invalid field!';
                text.title='Looks like this field does not exist anymore in your form. Please select another.';
                subCreator.CreateRawColumn(text,'FieldValue');
            }else{
                subCreator.CreateTextColumn('#'+fieldSettings.Label +'(Id:'+fieldSettings.Id+')','FieldValue');
            }

            creator.CreateRawColumn(subCreator.Table);

        }


    }
}
